import { render, staticRenderFns } from "./Caja.vue?vue&type=template&id=1bd47a2a&scoped=true"
import script from "./Caja.vue?vue&type=script&lang=js"
export * from "./Caja.vue?vue&type=script&lang=js"
import style0 from "./Caja.vue?vue&type=style&index=0&id=1bd47a2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd47a2a",
  null
  
)

export default component.exports